// JavaScript source code
import React, { useState, useEffect, useRef} from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import SubHeader from '../components/subheader';
import SubFooter from '../components/subfooter';
import LeftNav from '../components/leftnav';
import LoginDialog from '../components/loginDialog';
import ViewInvoiceDialog from '../components/viewInvoiceDialog';
import Cart from '../components/cart';
import LoadingOverlay from '../components/loadingOverlay';
import MessageDialog from '../components/messageDialog';
import { get, getUser, handleImageError,getCart } from '../request';
import Input from '../components/input';
import Button from '../components/button';
import CheckBox from '../components/checkbox';
import Pagination from '../components/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import moment from 'moment';
import dataFoot from '../assets/fake-data/data-foot';
function InvoiceManagement(props) {
    const activeIndex = 5;
    const tabs = [{ id: 0, name: "可申请发票订单" },
    { id: 1, name: "已申请发票" }];
    const [errorMessage, setErrorMessage] = useState("");
    const [currentTab, setCurrentTab] = useState(0);
    const navigate = useNavigate();
    const [isCrossTotalVisible, setIsCrossTotalVisible] = useState(false);
    const [isShowLogin, setIsShowLogin] = useState(false);
    const [isShowInvoice, setIsShowInvoice] = useState(false);
    const [invoceTitle, setInvoceTitle] = useState("申请发票");
    const [isLoading, setShowLoading] = useState(false);
    var user = getUser();
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPage1, setCurrentPage1] = useState(1);
    const [cartlist, setCartlist] = useState([]);

    const itemsPerPage = 4;
    const [totalItems, setTotalItems] = useState(0);
    const [totalItems1, setTotalItems1] = useState(0);

    const [invoiceProducts, setInvoiceProducts] = useState([]);
    const [invoicelist, setInvoicelist] = useState([]);    
    const [ordercheckedlist, setOrdercheckedlist] = useState([]);    
    const [invoiceTotalPrice, setInvoiceTotalPrice] = useState(0);
    const [item, setItem] = useState({});
    const [addresslist, setAddressist] = useState([]);

    const [invoiceItem, setInvoiceItem] = useState({
        id: 0,
        invoiceStatus: 0,
        business: '',
        businessId: 0,
        totalPrice: 0,
        invoiceType: 0,
        invoiceTitle: '',
        invoiceStatusName: '',
        address: null,
        postAddress: '',
        postPhone: '',
        postMan: '',
        taxpayerCode: '',
        taxpayerAddress: '',
        taxpayerPhone: '',
        bankName: '',
        bankAccount: '',
        linkMan: '',
        linkPhone: '',

        businessType: 0,
        creatorUser: user,
        businessAskInvoiceProductEntityList: ''

    });

    const [orderlist, setOrderlist] = useState([]);
    const [searchparams, setSearchparams] = useState({
        searchDateFrom: moment().format("YYYY-MM-DD"),
        searchDateTo: moment().format("YYYY-MM-DD"),
        searchType: 1
    });
    const handleTabChange = (tab) => {
        setCurrentTab(tab);
        if (tab == 0) {
            getConsultation(1, -1, tab);
        }
        else {
            getInvoiceList(1, -1, tab);
        }
    };
    const [screenSize, setScreenSize] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (user == null ) {
            setIsShowLogin(true);
            //history.goBack();
        }       
        else {
            get('delianapi/business/my').then((response) => {
                if (response.statusCode !== 200 || response.items.length == 0) {
                    return;
                }
                setItem(response.items[0]);
                setAddressist(response.items[0].deliveryAddressList);
                handleTabChange(0);
                getCart().then(function (response) {
                    if (response.statusCode !== 200) {
                        setErrorMessage("请重新登录！");
                        setIsShowLogin(true);
                        return;
                    }
                    setCartlist(response.items.filter(function (c) { return c.sku; }));
                });
            });
        }
    }, []);


    const handleInputChange = (name, value) => {
        var date = moment(value).format("YYYY-MM-DD");
        setSearchparams({
            ...searchparams,
            [name]: date
        });

    };

    const handlePageChange = (page) => {
        if (currentTab == 0) {
            setCurrentPage(page);
        }
        else {
            setCurrentPage1(page);
        }
    };

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    //const currentItems = items.slice(startIndex, endIndex);
    const search = (type) => {
        getInvoiceList(currentPage, type);
    }

    const getConsultation = (pageIndex, type, tab) => {
       
        setShowLoading(true);
        get('delianapi/order/query?orderType=purchase&IsNotInvoice=true&pageIndex=' + pageIndex +
            '&pageSize=' + itemsPerPage).then((response) => {
            if (response.statusCode == 200) {
                //recordCount = response.recordCount;
                setCurrentPage(1);
                setTotalItems(response.recordCount);
                setShowLoading(false);
                var orders = response.items;
                fillCheckedStatus(orders, invoiceProducts);
                setOrderlist(orders);
            }
        });
    }

    const getInvoiceList = (pageIndex, type, tab) => {
        var url = 'delianapi/businessaskinvoice/query?pageIndex=' + pageIndex +
            '&pageSize=' + itemsPerPage;
        var begin = moment();
        var end = moment();
        var searchType = type ?? searchparams.searchType;
        if (searchType == 1) {
            begin = moment().subtract(1, 'months');
        } else if (searchType == 2) {
            begin = moment().subtract(3, 'months');
        } else if (searchType == 3) {
            begin = moment().subtract(1, 'years');
        } else {
            begin = moment(searchparams.searchDateFrom);
            end = moment(searchparams.searchDateTo);
        }

        var begintime = begin.format("YYYY-MM-DD");
        var endtime = end.format("YYYY-MM-DD");
        setSearchparams({
            ...searchparams,
            ["searchDateFrom"]: begintime,
            ["searchDateTo"]: endtime,
            ["searchType"]: searchType
        });

        url += '&CreationTimeFrom=' + begintime;
        url += '&CreationTimeTo=' + endtime;       
        setShowLoading(true);
        get(url).then((response) => {
            if (response.statusCode == 200) {
                //recordCount = response.recordCount;
                setCurrentPage(1);
                setTotalItems1(response.recordCount);
                setShowLoading(false);

                var invoicelist = response.items;
                calInvoiceTotalPrice(invoicelist);
                setInvoicelist(invoicelist);
                // enableBtnRight(); todo
            }
        });
    }
    const calInvoiceTotalPrice =(invoicelist)=> {
        for (var i = invoicelist.length; i--;) {
            var invoice = invoicelist[i];
            invoice.totalPrice = 0;
            invoice.totalQuantity = 0;
            for (var j = invoice.businessAskInvoiceProductEntityList.length; j--;) {
                var product = invoice.businessAskInvoiceProductEntityList[j];
                if (product.productSkuImageUrl) {
                    product.productSkuImageUrl = product.productSkuImageUrl + '.small.png';
                }
                else {
                    product.productSkuImageUrl = dataFoot.noimageSmall;
                }
                invoice.totalPrice += product.outInNum * product.unitPrice;
                invoice.totalQuantity += product.outInNum;
            }
            invoice.totalPrice = parseFloat(invoice.totalPrice).toFixed(2);
        }
        var newOrdercheckedlist = invoicelist.map(function (item) {
            return {
                id: item.id,
                checked: item.checked
            }
        });
        setOrdercheckedlist(newOrdercheckedlist);
    }
    const getColorCss = (statusName) => {
        if (statusName == '已送达' || statusName == '部分送达') {
            return 'status-green';
        } else if (statusName == '待确认' || statusName == '出库审核' || statusName == '配货中') {
            return 'status-gray';
        } else if (statusName == '已确认' || statusName == '已出库' || statusName == '部分出库' || statusName == '已发货' || statusName == '部分发货') {
            return 'status-blue';
        }
    }
    const calOrderTotalWeight = (order) => {
        order.totalWeight = 0;
        order.totalQuantity = 0;
        for (var j = order.orderProductEntityList.length; j--;) {
            var product = order.orderProductEntityList[j];
            product.totalWeight = (parseFloat(product.weight) * parseFloat(product.quantity)).toFixed(2);
            order.totalWeight += product.totalWeight;
            order.totalQuantity += product.quantity;
        }
    }
    const handleLoginClick = () => {
        setIsShowLogin(true);
    }
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }

    const toggleCrossTotal = ()=> {
        setIsCrossTotalVisible(!isCrossTotalVisible);
    }
    const deleteInvoice = (product) =>{
        var newInvoiceProducts = invoiceProducts.filter(function (item, i) {
            return item.askInvoiceId != product.askInvoiceId;
        });
        setInvoiceProducts(newInvoiceProducts);
        calInvoicePrice(newInvoiceProducts);
        fillCheckedStatus(orderlist, newInvoiceProducts);
    }
    const fillCheckedStatus = (newValue, newInvoiceProducts)=> {
        for (var i = newValue.length; i--;) {
            var order = newValue[i];
            order.totalPrice = 0;
            order.checked = true;
            order.totalQuantity = 0;
            for (var j = order.orderProductEntityList.length; j--;) {
                var product = order.orderProductEntityList[j];
                if (product.productSkuImageUrl) {
                    product.productSkuImageUrl = product.productSkuImageUrl + '.small.png';
                }
                else {
                    product.productSkuImageUrl = dataFoot.noimageSmall;
                }
                order.totalPrice += product.outInNum * product.unitPrice;
                order.totalQuantity += product.outInNum;
                var find = newInvoiceProducts.filter(function (item, i) {
                    return item.askInvoiceId == product.askInvoiceId;
                });
                product.checked = (find.length > 0);
                if (!product.checked) {
                    order.checked = false;
                }
            }
        }
        var newOrdercheckedlist = newValue.map(function (item) {
            return {
                id: item.id,
                checked: item.checked
            }
        });
        setOrdercheckedlist(newOrdercheckedlist);
    }
    const apply =  ()=> {
        //初始化
        if (invoiceProducts.length == 0) {
            return;
        }
        invoiceItem.businessAskInvoiceProductEntityList = invoiceProducts;

        invoiceItem.business = item;
        invoiceItem.businessId = item.id;
        invoiceItem.businessType = item.businessTypeId;
        invoiceItem.invoiceType = 0;
        var invoice = item.businessInvoiceInfoList.filter(function (item) {
            return item.invoiceType == invoiceItem.invoiceType
        });
        if (invoice.length > 0) {
            invoiceItem.invoiceTitle = invoice[0].invoiceTitle;
            invoiceItem.taxpayerCode = invoice[0].taxpayerCode;
            invoiceItem.taxpayerAddress = invoice[0].taxpayerAddress;
            invoiceItem.taxpayerPhone = invoice[0].taxpayerPhone;
            invoiceItem.bankName = invoice[0].bankName;
            invoiceItem.bankAccount = invoice[0].bankAccount;
        }
        var address = item.deliveryAddressList.filter(function (item) {
            return item.isDefault;
        });
        if (address.length > 0) {
            invoiceItem.postAddress = address[0].address;
            invoiceItem.postPhone = address[0].mobilePhone;
            invoiceItem.postMan = address[0].contactName;
            invoiceItem.address = address[0];
        }
        invoiceItem.totalPrice = invoiceTotalPrice;
        setInvoiceItem(invoiceItem);
        setIsShowInvoice(true);
        setIsCrossTotalVisible(false);
    };
    const handCheckChange = (order, product, value) => {
        if (!product) {//全选  
            order.checked = value;
            var oldorder = ordercheckedlist.filter(function (item) {
                return item.id == order.id
            });
            //和原来的额订单选择状态不同，说明点击了订单的全选
            if (oldorder.length > 0 && oldorder[0].checked != order.checked) {
                for (var j = order.orderProductEntityList.length; j--;) {
                    var product = order.orderProductEntityList[j];
                    product.checked = order.checked;
                }
            } else {
                order.checked = true;
            }
        }
        else {
            product.checked = value;
            order.checked = order.orderProductEntityList.every(item => item.checked);
        }
        var newInvoiceProducts = invoiceProducts;
        for (var j = order.orderProductEntityList.length; j--;) {
            var product = order.orderProductEntityList[j];

            if (product.checked) {
                var find = invoiceProducts.filter(function (item, i) {
                    return item.askInvoiceId == product.askInvoiceId;
                });
                if (find.length == 0) {
                    product.orderProductId = product.id;
                    product.productSkuType = product.sku;
                    product.orderCode = order.recordNo;
                    newInvoiceProducts = [...newInvoiceProducts, product];
                    setInvoiceProducts(newInvoiceProducts);
                }
            } else {
                newInvoiceProducts = newInvoiceProducts.filter(function (item, i) {
                    return item.askInvoiceId != product.askInvoiceId;
                });
                setInvoiceProducts(newInvoiceProducts);
                order.checked = false;
            }
        }
        calInvoicePrice(newInvoiceProducts);

        var newOrdercheckedlist = orderlist.map(function (item) {
            return {
                id: item.id,
                checked: item.checked
            }
        });
        setOrdercheckedlist(newOrdercheckedlist);
    }
    const calInvoicePrice = (newInvoiceProducts)=> {
        var newInvoiceTotalPrice = 0;
        for (var i = newInvoiceProducts.length; i--;) {
            var product = newInvoiceProducts[i];
            newInvoiceTotalPrice += product.outInNum * product.unitPrice;
        }
        newInvoiceTotalPrice = parseFloat(newInvoiceTotalPrice).toFixed(2);
        setInvoiceTotalPrice(newInvoiceTotalPrice);
    }
    const finishApplication = () => {
        handleTabChange(0);
        setIsShowInvoice(false);
    }
    const handleLocalImageError = (productId, type = 'small') => {
        // 调用公共的handleImageError函数  
        handleImageError(setErrorState, type, productId);
    };
    const handleLocalImageError1 = (productId, type = 'small') => {
        // 调用公共的handleImageError函数  
        handleImageError(setErrorState1, type, productId);
    };
    const handleLocalImageError2 = (productId, type = 'small') => {
        // 调用公共的handleImageError函数  
        handleImageError(setErrorState2, type, productId);
    };
    const setErrorState = (productId, defaultImageUrl) => {
        const oldlist = [...invoiceProducts];
        oldlist.forEach(function (item) {
            if (item.id == productId) {
                item.productSkuImageUrl = defaultImageUrl;
                item.error = true;
            }
        });
        setInvoiceProducts(oldlist);
    };
    const setErrorState1 = (productId, defaultImageUrl) => {
        const oldlist = [...orderlist];
        oldlist.forEach(function (item) {
            item.orderProductEntityList.forEach(function (product) {
                if (product.askInvoiceId == productId) {
                    product.productSkuImageUrl = defaultImageUrl;
                    product.error = true;
                }
            });
        });
        setOrderlist(oldlist);
    };
    const setErrorState2 = (productId, defaultImageUrl) => {
        const oldlist = [...invoicelist];
        oldlist.forEach(function (item) {
            item.businessAskInvoiceProductEntityList.forEach(function (product) {
                if (product.orderProductId == productId) {
                    product.productSkuImageUrl = defaultImageUrl;
                    product.error = true;
                }
            });
        });
        setInvoicelist(oldlist);
    };
    return (
        <div className="mydelian InvoiceManagement" >
            <SubHeader activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content">
                <div className="detail" >
                    <LeftNav type={2} selectId={212} />
                    <div className="myContent">
                        <div className="title">
                            发票管理
                            {
                                currentTab == 0 &&
                                <div className="title-right">
                                    <span className="toApplication">
                                        待申请发票金额：<small className="red fs-12">￥</small>
                                        <span className="red fs-20" >{invoiceTotalPrice}</span>
                                    </span>
                                    <Link className="invoicebtn fs-15" onClick={toggleCrossTotal}>
                                        待申请发票信息  
                                    </Link>
                                    {
                                        isCrossTotalVisible && (
                                            <div className="toApplicationDetail" id="crossTotal">
                                                <div className="total">
                                                    待申请发票金额：
                                                    <span className="red">
                                                        <small className="fs-12">
                                                            ￥</small>
                                                        <span className="fs-20" >
                                                            {invoiceTotalPrice}</span>
                                                    </span>
                                                </div>
                                                <div className="products">
                                                    {
                                                        invoiceProducts.map((product, index) => (
                                                            <div className="product" >
                                                                <div className="deleteIcon" onClick={() => deleteInvoice(product)}></div>
                                                                <img className="productImage"
                                                                    onError={() => handleLocalImageError(product.id, 'small')}
                                                                    src={product.productSkuImageUrl } alt="" />
                                                                <div className="info">
                                                                    <div className="name" >{product.productSkuName}</div>
                                                                    <div className="name " >{product.skuName}</div>
                                                                    <div >
                                                                        <small className="red">￥</small>
                                                                        <span className="fs-16 red" >{parseFloat(product.unitPrice).toFixed(2)}</span> ×
                                                                        <span >{product.outInNum}</span>
                                                                    </div>
                                                                    
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>

                                                <Button title="申请发票" className="btn btn-yellow button"
                                                    onClick={apply} disabled={invoiceProducts.length == 0}>
                                                    
                                                </Button>
                                                <div className="text-center slide" onClick={toggleCrossTotal}>
                                                    <a className="slide-up"></a>
                                                </div>
                                            </div>
                                            )
                                    }
                                   
                                </div>
                            }
                        </div>
                        <div className="tab-container">
                            <ul className="tab-list">
                                {tabs.map((tab) => (
                                    <li
                                        key={`tab${tab.id}`}
                                        className={`tab-item ${currentTab === tab.id ? 'active' : ''}`}
                                        onClick={() => handleTabChange(tab.id)}
                                    >
                                        {tab.name}
                                    </li>
                                ))}
                            </ul>
                            <div className="tab-content">                               
                                                            
                                {
                                    currentTab == 0 &&
                                    <div className="listDiv">
                                        {
                                            orderlist.length == 0 && <div className="nodata">暂无数据</div>
                                        }
                                        {
                                            orderlist.length > 0 &&
                                            (<ul>
                                                {
                                                    orderlist.map((order, index) => (
                                                        <li className="order" key={`order${order.id}`}>
                                                            <div className="recordNo">
                                                                订单编号：
                                                                <span className="orderNo"> {order.recordNo}</span>
                                                                <span className="orderDate">{moment(order.orderDate).format("YYYY-MM-DD")}</span>
                                                                <div className={`orderStatus ${getColorCss(order.statusName)}`}>{order.statusName}</div>
                                                            </div>
                                                            {
                                                                screenSize > 991 ? (
                                                                    <Swiper
                                                                        modules={[Navigation]}
                                                                        spaceBetween={30}
                                                                        slidesPerView={4}
                                                                        loop={false}
                                                                        navigation
                                                                    >
                                                                        {
                                                                            order.orderProductEntityList.map((product, index) => (
                                                                                <SwiperSlide key={`order-${order.id}-${product.askInvoiceId}`} className="orderProduct">
                                                                                    <CheckBox value={product.checked || false} name={`check-${order.id}-${product.askInvoiceId}`}
                                                                                        onChange={(value) => handCheckChange(order, product, value)}
                                                                                    />
                                                                                    <img className="productImage" src={product.productSkuImageUrl}
                                                                                        onError={() => handleLocalImageError1(product.askInvoiceId, 'small')} />
                                                                                   
                                                                                    <div className="productPri">
                                                                                        <span className="red" >
                                                                                            <small >￥</small>
                                                                                            <span className="price" >{parseFloat(product.unitPrice).toFixed(2)}</span>
                                                                                        </span>
                                                                                        ×<span >{product.outInNum}</span>
                                                                                    </div>
                                                                                    <div> {product.skuName}</div>
                                                                                    <div> {product.productSkuName}</div>
                                                                                    <div className={`status ${getColorCss(product.erpOrderItemStatusName)}`} >
                                                                                        {product.erpOrderItemStatusName}
                                                                                    </div>
                                                                                </SwiperSlide>
                                                                            ))
                                                                        }
                                                                    </Swiper>
                                                                ) : (
                                                                        <div>{
                                                                            order.orderProductEntityList.map((product, index) => (
                                                                                <div key={`order-${order.id}-${product.askInvoiceId}`} className="orderProduct">
                                                                                    <CheckBox value={product.checked || false} name={`check-${order.id}-${product.askInvoiceId}`}
                                                                                        onChange={(value) => handCheckChange(order, product, value)}
                                                                                    />
                                                                                    <img className="productImage" src={product.productSkuImageUrl}
                                                                                        onError={() => handleLocalImageError1(product.askInvoiceId, 'small')} />
                                                                                    <div className="skuName">                                                                                        
                                                                                        <div> {product.productSkuName}</div>
                                                                                        <div className="sn"> {product.skuName} </div>
                                                                                        
                                                                                    </div>
                                                                                    <div className="productPri">
                                                                                        <span className="red" >
                                                                                            <small >￥</small>
                                                                                            <span className="price" >{parseFloat(product.unitPrice).toFixed(2)}</span>
                                                                                        </span>
                                                                                        <span >×{product.outInNum}</span>

                                                                                        <div className={`status ${getColorCss(product.erpOrderItemStatusName)}`} >
                                                                                            {product.erpOrderItemStatusName}
                                                                                        </div>
                                                                                    </div>
                                                                                    
                                                                                   
                                                                                </div>
                                                                            ))
                                                                        }
                                                                        </div>
                                                                )
                                                            }
                                                            
                                                            <div className="totalPrice ">
                                                                <CheckBox value={order.checked} title="全选" name={`allcheck${order.id}`}
                                                                    onChange={(value) => handCheckChange(order, null, value)} />
                                                                <div className="selectall">
                                                                   
                                                                    共计 <span className="red " >{order.totalQuantity}</span> 件产品 合计：
                                                                    <span className="red ">￥<span className="fs-22 ">
                                                                        {parseFloat(order.totalPrice).toFixed(2)}</span>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))
                                                }
                                             </ul>  )
                                           
                                        }
                                        {
                                            orderlist.length > 0 && <Pagination
                                                totalItems={totalItems}
                                                itemsPerPage={itemsPerPage}
                                                onPageChange={handlePageChange}
                                            />
                                        }
                                    </div>
                                }
                                {
                                    currentTab == 1 &&
                                    (
                                        <div className="searchDiv">
                                            <div>
                                            <Button btnclass={`searchBtn ${searchparams.searchType == 1 ? 'active' : ''}`} onClick={() => search(1)} title="1个月"></Button>
                                            <Button btnclass={`searchBtn ${searchparams.searchType == 2 ? 'active' : ''}`} onClick={() => search(2)} title="2个月"></Button>
                                            <Button btnclass={`searchBtn ${searchparams.searchType == 3 ? 'active' : ''}`} onClick={() => search(3)} title="1年"></Button>
                                            </div><div>
                                                <Input className="searchInput" inputType="date" value={searchparams.searchDateFrom}
                                                placeholder="下单开始日期 " onChange={value => handleInputChange('searchDateFrom', value)} />
                                            至
                                            <Input className="searchInput" inputType="date" value={searchparams.searchDateTo}
                                                placeholder="下单结束日期 " onChange={value => handleInputChange('searchDateTo', value)} />

                                            <Button btnclass={`searchBtn search &{searchparams.searchDateFrom || searchparams.searchDateTo?'active':''}`} onClick={() => search(4)} title="查询">
                                                </Button>
                                            </div>
                                        </div>    )
                                }
                                {
                                    currentTab == 1 &&
                                    <div className="listDiv">
                                        {
                                            invoicelist.length == 0 && <div className="nodata">暂无数据</div>
                                        }
                                        {
                                            invoicelist.length > 0 &&
                                            <ul className="invoice">
                                                {
                                                invoicelist.map((invoice, index) => (
                                                    <li className=" " key={`invoice${invoice.id}`}>
                                                        <div className="recordNo">
                                                            发票抬头：
                                                            <span className="orderNo"> {invoice.invoiceTitle}</span>
                                                            {
                                                                screenSize <=991 && <br/>
                                                            }
                                                            <span className="orderNo">发票类型： {invoice.invoiceTypeName}</span>
                                                            <span className="orderDate">{moment(invoice.creationTime).format("YYYY-MM-DD")}
                                                                
                                                            </span>
                                                            <div className="orderStatus">
                                                                {invoice.invoiceStatusName}
                                                            </div>
                                                        </div>
                                                        <div className="product-container">
                                                            {
                                                                screenSize>991 ?
                                                                (<Swiper
                                                                    modules={[Navigation]}
                                                                    spaceBetween={30}
                                                                    slidesPerView={4}
                                                                    loop={false}
                                                                    navigation
                                                                >
                                                                    {
                                                                        invoice.businessAskInvoiceProductEntityList.map((product, index) => (
                                                                            <SwiperSlide key={`invoice${product.orderProductId}`} className="orderProduct">

                                                                                <img className="productImage"
                                                                                    src={product.productSkuImageUrl}
                                                                                    onError={() => handleLocalImageError2(product.orderProductId, 'small')} />
                                                                                <div className={`status ${getColorCss(product.erpOrderItemStatusName)}`} >
                                                                                    {product.erpOrderItemStatusName}
                                                                                </div>
                                                                                <div className="productPri">
                                                                                    <span className="red" >
                                                                                        <small >￥</small>
                                                                                        <span className="price" >{product.unitPrice}</span>
                                                                                    </span>
                                                                                    ×<span >{product.quantity}</span>
                                                                                </div>
                                                                                <div> {product.productSkuName}</div>
                                                                            </SwiperSlide>
                                                                        ))
                                                                    }
                                                                    </Swiper>) : (
                                                                        <div className="">
                                                                            {
                                                                                invoice.businessAskInvoiceProductEntityList.map((product, index) => (
                                                                                    <div  className="orderProduct">
                                                                                        <img className="productImage"
                                                                                            src={product.productSkuImageUrl}
                                                                                            onError={() => handleLocalImageError2(product.orderProductId, 'small')} />
                                                                                        <div className="productSkuName"> {product.productSkuName}</div>
                                                                                        <div className="productPri">
                                                                                            <span className="red" >
                                                                                                <small >￥</small>
                                                                                                <span className="price" >{product.unitPrice}</span>
                                                                                            </span>
                                                                                            ×<span >{product.quantity}</span>
                                                                                        </div>
                                                                                       
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    )
                                                            }
                                                        </div>
                                                        <div className="totalPrice">
                                                            共计 <span className="red">{invoice.totalQuantity}</span> 件产品 合计：
                                                            ￥<span className="red fs-22">{parseFloat(invoice.totalPrice).toFixed(2)}</span>
                                                        </div>
                                                    </li>
                                                ))}                                                     
                                                   
                                            </ul>
                                                                                        
                                          
                                        }
                                        {
                                            invoicelist.length > 0 && <Pagination
                                                totalItems={totalItems1}
                                                itemsPerPage={itemsPerPage}
                                                onPageChange={handlePageChange}
                                            />
                                        }
                                    </div>

                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                screenSize <= 991 && currentTab == 0 && (
                    <div className="fixed-bottom">
                        <div className="toApplication">
                            待申请发票金额：<small className="red fs-12">￥</small>
                            <span className="red fs-22" >{invoiceTotalPrice}</span>
                        </div>
                        <Button title="申请发票" className="btn btn-yellow button"
                            onClick={apply} disabled={invoiceProducts.length == 0}>

                        </Button>
                    </div>)
            }
            {
                cartlist &&
                <Cart num={cartlist.length} />
            }
            <SubFooter />
            <ViewInvoiceDialog initItem={invoiceItem} invoiceTotalPrice={invoiceTotalPrice}
                list={addresslist} isShow={isShowInvoice} title={invoceTitle}
                onCancel={() => { setIsShowInvoice(false); }} onConfirm={ finishApplication}/>
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
            <MessageDialog message={errorMessage} onCancel={() => {
                setErrorMessage("");
                navigate(-1);
            }} />
            <LoadingOverlay isLoading={isLoading}>
            </LoadingOverlay>
        </div>

    );
}

export default InvoiceManagement;